module.exports = {
  messages: {
    CN: {
      OptWelcome: "欢迎回来，{name} - StrategyBrain 是您的 AI 招聘助手",
      OptHeroSubtitle: "同步 LinkedIn。剩下的交给我们。",
      OptHeroCopy: "您的 24/7 AI 招聘助手会在后台自动工作：",
      OptHeroFlow: "寻找人才 → 发起联系 → 筛选意向",
      OptHeroTakeover: "您只需接手有热情的潜在候选人。",
      OptActionTitle: "想先了解它是如何工作的，还是直接开始？",
      OptActionDesc:
        "不确定？观看 30 秒示例，或让 AI 为您制定招聘策略。已经清楚？直接创建您的任务。",
      OptWatchExample: "观看真实示例（30 秒）",
      OptCreateCampaign: "创建任务",
      OptStrategyTooltip:
        "回答三个快速问题，AI 就会确定：目标人群、从哪里找到他们、如何开启对话",
      OptStrategyBtn: "不确定如何招聘？让 AI 为您制定策略（约 1 分钟）",
      OptCard1Title: "它是什么",
      OptCard1Content:
        "基于 LinkedIn 的 AI 招聘助手，全天候工作，为您处理繁琐的寻源和筛选工作。",
      OptCard2Title: "适合谁",
      OptCard2Content:
        "全球招聘团队、企业 HR、猎头和猎头公司——希望更高效地在 LinkedIn 上招聘、同时花费更少时间的团队和个人。",
      OptCard3Title: "您能得到什么",
      OptCard3Content: "寻源、外联、初步沟通和意向筛选——全部自动化。",
      OptCard3Badge: "平均每天 20+ 合格候选人*",
      OptSaleWelcome: "欢迎回来，{name} —— StrategyBrain 是您的 AI 销售代表",
      OptSaleCopy1: "连接 LinkedIn 后，它会 24/7 全天候工作，为您找到合适的目标客户 →",
      OptSaleCopy2:
        "自动联系 → 并通过 AI 对话筛选出感兴趣的潜在客户。您只需接手有热情的商机。",
      OptSaleCopy3: "您只需接手有热情的商机。",
      OptSaleCard1Content:
        "基于 LinkedIn 的 AI 销售代表，全天候工作，为您处理繁琐的潜在客户挖掘和初步外联。",
      OptSaleCard2Content:
        "全球销售团队、SDR / BD 团队，以及外贸 / SaaS 获客——希望在 LinkedIn 上更高效地获取潜在客户、同时花费更少时间的团队和个人。",
      OptSaleCard3Content: "潜在客户挖掘、外联、初步沟通和意向筛选——全部自动化。",
      OptSaleCard3Badge: "平均每月 20+ 感兴趣客户 / 商机预约*",
    },
    US: {
      OptWelcome: "Welcome, {name} - StrategyBrain is your AI recruiter",
      OptHeroSubtitle: "Sync LinkedIn. We Handle the Rest.",
      OptHeroCopy: "Your 24/7 AI Recruiter automatically works in the background:",
      OptHeroFlow: "Source Talent &rarr; Initiate Contact &rarr; Screen for Intent",
      OptHeroTakeover: "Simply take over the warm leads.",
      OptActionTitle: "Want to see how it works first, or jump right in?",
      OptActionDesc:
        "Not sure? Watch the 30-second example or let AI draft a hiring strategy for you. Already clear? Create your campaign directly.",
      OptWatchExample: "Watch a real example (30s)",
      OptCreateCampaign: "Create a campaign",
      OptStrategyTooltip:
        "Answer three quick questions and AI defines: who to target, where to find them, and how to open",
      OptStrategyBtn:
        "Not sure how to hire? Let AI build your strategy (~1 min)",
      OptCard1Title: "What it is",
      OptCard1Content:
        "A LinkedIn-based AI recruiter working 24/7 to handle the tedious sourcing and screening for you.",
      OptCard2Title: "Who it’s for",
      OptCard2Content:
        "Global hiring teams, in-house HR, recruiters, and search firms - teams and individuals who want to hire on LinkedIn more efficiently while spending far less time on it.",
      OptCard3Title: "What you get",
      OptCard3Content:
        "Sourcing, outreach, first chats, and interest screening - all automated.",
      OptCard3Badge: "Avg. 20+ Qualified Candidates / Day*",
      OptSaleWelcome: "Welcome, {name} — StrategyBrain is your AI sales rep",
      OptSaleCopy1:
        "Once you connect LinkedIn, it works 24/7 to find the right target customers →",
      OptSaleCopy2:
        "reach out automatically → and surface interested prospects through AI conversations. You just take over the warm opportunities.",
      OptSaleCopy3: "You just take over the warm opportunities.",
      OptSaleCard1Content:
        "A LinkedIn-based AI sales rep working 24/7 to handle the tedious prospecting and initial outreach for you.",
      OptSaleCard2Content:
        "Global sales teams, SDR / BD teams, and foreign-trade / SaaS lead gen – teams and individuals who want to generate leads on LinkedIn more efficiently while spending far less time on it.",
      OptSaleCard3Content:
        "Prospecting, outreach, first chats, and interest screening – all automated.",
      OptSaleCard3Badge:
        "On average, 20+ interested customers / opportunities booked every month*",
    },
    AR: {
      OptWelcome:
        "مرحبًا، {name} - StrategyBrain هو مسؤول التوظيف الذكي الخاص بك",
      OptHeroSubtitle: "مزامنة LinkedIn. نحن نتولى الباقي.",
      OptHeroCopy: "يعمل مسؤول التوظيف الذكي الخاص بك 24/7 تلقائيًا في الخلفية:",
      OptHeroFlow: "البحث عن المواهب ← بدء التواصل ← فحص الاهتمام",
      OptHeroTakeover: "فقط استلم العملاء المحتملين المهتمين.",
      OptActionTitle: "هل تريد أن ترى كيف يعمل أولًا، أم تبدأ مباشرة؟",
      OptActionDesc:
        "غير متأكد؟ شاهد المثال لمدة 30 ثانية أو دع الذكاء الاصطناعي يضع استراتيجية التوظيف لك. هل أنت واضح؟ أنشئ حملتك مباشرة.",
      OptWatchExample: "شاهد مثالًا حقيقيًا (30 ثانية)",
      OptCreateCampaign: "إنشاء حملة",
      OptStrategyTooltip:
        "أجب عن ثلاثة أسئلة سريعة وسيحدد الذكاء الاصطناعي: من تستهدف، ومن أين تجدهم، وكيف تبدأ المحادثة",
      OptStrategyBtn:
        "لست متأكدًا من كيفية التوظيف؟ دع الذكاء الاصطناعي يبني استراتيجيتك (حوالي دقيقة واحدة)",
      OptCard1Title: "ما هو",
      OptCard1Content:
        "مسؤول توظيف ذكي يعتمد على LinkedIn ويعمل على مدار الساعة للتعامل مع مهام البحث والفحص المملة نيابة عنك.",
      OptCard2Title: "لمن هذا المنتج",
      OptCard2Content:
        "فرق التوظيف العالمية، والموارد البشرية الداخلية، ومسؤولي التوظيف، وشركات البحث عن الكفاءات - فرق وأفراد يريدون التوظيف عبر LinkedIn بكفاءة أكبر مع قضاء وقت أقل بكثير.",
      OptCard3Title: "ماذا ستحصل",
      OptCard3Content:
        "البحث عن المواهب، والتواصل، والمحادثات الأولى، وفحص الاهتمام - كل ذلك آليًا.",
      OptCard3Badge: "متوسط 20+ مرشحًا مؤهلًا / يوم*",
      OptSaleWelcome:
        "مرحبًا، {name} — StrategyBrain هو مندوب المبيعات الذكي الخاص بك",
      OptSaleCopy1:
        "بمجرد ربط LinkedIn، يعمل على مدار الساعة للعثور على العملاء المستهدفين المناسبين ←",
      OptSaleCopy2:
        "يتواصل تلقائيًا ← ويكشف العملاء المحتملين المهتمين عبر محادثات الذكاء الاصطناعي. ما عليك سوى تولي الفرص الدافئة.",
      OptSaleCopy3: "ما عليك سوى تولي الفرص الدافئة.",
      OptSaleCard1Content:
        "مندوب مبيعات ذكي يعتمد على LinkedIn ويعمل على مدار الساعة للتعامل مع البحث الممل عن العملاء المحتملين والتواصل الأولي نيابة عنك.",
      OptSaleCard2Content:
        "فرق المبيعات العالمية، وفرق SDR / BD، وتوليد العملاء المحتملين للتجارة الخارجية / SaaS – فرق وأفراد يريدون توليد عملاء محتملين على LinkedIn بكفاءة أكبر مع قضاء وقت أقل بكثير.",
      OptSaleCard3Content:
        "البحث عن العملاء المحتملين، والتواصل، والمحادثات الأولى، وفحص الاهتمام – كل ذلك آليًا.",
      OptSaleCard3Badge: "في المتوسط، 20+ عميلًا مهتمًا / فرصة محجوزة كل شهر*",
    },
  },
};
